<template>
    <ContentComponent />
</template>

<script>
    import ContentComponent from '@/components/ContactPage/ContentComponent'

    export default {
        name: "Contact",
        components: {
            ContentComponent
        }
    }
</script>

<style scoped>

</style>
